export default __webpack_public_path__ + "static/media/home.6015617c.mp4";